export default __webpack_public_path__ + "static/AppIcon@2x-7897ac9a3d572e74ed26bc3a997ed6cd.png";